/*
 * @Author: zhengxiaowen 
 * @Date: 2018-10-11 19:21:09 
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 17:05:47
 */


import demoPage from '../demoPage'



let router = [
    {
        path: '/demoPage',
        component: demoPage,
        backPath:'root',
        cnName:'demoPage',
        meta:{
            keepAlive: false,
        }
    },
    // {
    //     path: '/demoPage',
    //     component: demoPage,
    //     backPath:'',
    //     cnName:'demoPage',
    //     meta:{
    //         keepAlive: false,
    //     }
    // },
]

export default router


// WEBPACK FOOTER //
// ./src/page/devDemo/config/router.js